export default __webpack_public_path__ + "380904e60a46c072fa738e51d7635150.svg";